
export default {
    name: 'Blank',
    middleware: ['auth'],
}
